import Divider from "@mui/material/Divider/Divider";
import Grid from "@mui/material/Grid/Grid";
import Typography from "@mui/material/Typography/Typography";

import {
  AutocompleteComponent,
  InputFilterComponent,
  InputFormatComponent,
} from "../../../../../components";

const ValuesSectionComponent = ({ control, isLoading, bankOptions }) => {
  return (
    <div>
      <Typography
        style={{
          fontWeight: "600",
          fontSize: "1.75vh",
          color: "#5C5C5C",
        }}
      >
        VALORES DA PROPOSTA
      </Typography>
      <Divider style={{ marginBottom: "2vh" }} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <AutocompleteComponent
                name="bank"
                control={control}
                label="BANCO"
                acessorLabel="label"
                acessorValue="id"
                options={bankOptions}
                disabled={isLoading}
              />
            </Grid>
            <Grid item xs={4}>
              <InputFormatComponent
                name="parcelValue"
                control={control}
                label="VALOR DA PARCELA"
                placeholder="VALOR DA PARCELA"
                format="R$"
                disabled={isLoading}
              />
            </Grid>
            <Grid item xs={4}>
              <InputFilterComponent
                name="parcelQuantity"
                control={control}
                label="QUANTIDADE DE PARCELAS"
                placeholder="QUANTIDADE DE PARCELAS"
                disabled={isLoading}
                type="number"
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default ValuesSectionComponent;
